import { getVueTemplate } from "../../_imports/utils/utils.common";
import FormsBaseInputField from "./_imports/forms-base-input-field.vue";

export default {
    name: 'forms-phone-field',
    template: getVueTemplate('forms-phone-field'),
    mixins: [
        FormsBaseInputField
    ],
    data() {
        return {
            doneTypingTimeout: 500,
        }
    },
    created() {
        this.addValidations();
    },
    methods: {
        addValidations() {
            this.addFieldValidation(validation => {
                if (!this.userInput) {
                    return validation.hasPassed();
                }

                let isValid = true;

                const phoneRegex = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;

                if (!this.userInput) {
                    return validation.hasPassed();
                }

                isValid = phoneRegex.test(String(this.userInput).toLowerCase());

                if (isValid) {
                    return validation.hasPassed();
                }

                return validation.hasFailed(this.getFieldErrorMessage('invalidPhoneError'));
            });
        }
    }
};